import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { Table, notification, Tag } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import { AuthContext } from 'context/AuthContext';
import terminalService from 'services/terminal.service';
import branchService from 'services/branch.service';
// import CheckAuth from 'components/common/CheckAuth';
// import authorities from 'helpers/authorities';
import AddForm from './components/AddForm';

class Terminal extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      terminals: [],
      branch: undefined,
      loading: false,
      branchId: props?.params?.branchId,
      currentMerch: context?.selectedMerch,
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">Terminal Sicil No</div>,
          dataIndex: 'SicilNumber',
          key: 'SicilNumber',
          align: 'center',
          width: 200,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">{row?.SicilNumber}</span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Marka</div>,
          dataIndex: 'clientMarkaName',
          key: 'clientMarkaName',
          align: 'center',
          width: 200,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">{row?.clientMarkaName}</span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Model</div>,
          dataIndex: 'clientModelName',
          key: 'clientModelName',
          align: 'center',
          width: 200,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">{row?.clientModelName}</span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Terminal Durumu</div>,
          dataIndex: 'okcStatusName',
          key: 'okcStatusName',
          align: 'center',
          width: 200,
          render: (okcStatusName, record) => (
            <Tag color={okcStatusName === 'Aktif' ? 'green' : 'volcano'} key={record?.identifier}>
              {okcStatusName}
            </Tag>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getCurrentBranchTerminals();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.getCurrentBranchTerminals();
    }
  }

  getCurrentBranchTerminals = async () => {
    this.getBranchDetails();
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      try {
        const { currentMerch } = this.state;
        if (currentMerch?.number) {
          const { branchId } = this.state;
          const { payload } = await terminalService.getTerminalsByBranch(
            currentMerch?.number,
            branchId,
          );
          this.setState({ loading: false, terminals: payload });
        }
      } catch (error) {
        this.setState({ loading: false, terminals: [] });
        notification.error({
          message: 'İşlem Başarısız',
          description: error,
        });
      }
    });
  };

  getBranchDetails = () => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      try {
        const { currentMerch } = this.state;
        if (currentMerch?.number) {
          const { branchId } = this.state;
          const { payload } = await branchService.getBranchDetail(currentMerch?.number, branchId);
          this.setState({ loading: false, branch: payload });
        }
      } catch (error) {
        this.setState({ loading: false, terminals: [], branch: {} });
        notification.error({
          message: 'İşlem Başarısız',
          description: error,
        });
      }
    });
  };

  render() {
    const { terminals, columns, loading, branch, branchId, visible, error } = this.state;

    return (
      <PageContainer
        className="site-page-header"
        title="Terminal İşlemleri"
        subTitle={`${branch ? branch.BranchTitle : ''} Şubesine ait terminaller listelenmektedir.`}
        onBack={() => this.props.navigate(-1)}
        extra={[
          // <CheckAuth authorityCode={authorities.ADD_TERMINAL} key="add-terminal">
          //   <NavLink to={{ pathname: `/basvurular/yeni-terminal-basvurusu/${branchId}` }}>
          //     <Button key="1" type="primary" icon={<PlusOutlined />}>
          //       Yeni Terminal Ekle
          //     </Button>
          //   </NavLink>
          // </CheckAuth>,
        ]}
      >
        <Table
          loading={loading}
          dataSource={terminals}
          columns={columns}
          pagination={false}
          rowKey="SerialNumber"
        />
        {visible && (
          <AddForm
            submitting={false}
            error={error}
            visible={visible}
            handleCloseForm={() => this.setState({ visible: false })}
          />
        )}
      </PageContainer>
    );
  }
}

Terminal.contextType = AuthContext;

Terminal.propTypes = {
  navigate: PropTypes.func.isRequired,
  params: PropTypes.shape({
    branchId: PropTypes.string,
  }).isRequired,
};

const TerminalWrapper = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  return <Terminal {...props} navigate={navigate} params={params} />;
};

export default TerminalWrapper;
